var Acr = Acr || {};

Acr.YouTubeManager = (function () {
  var players = [];
  var videoCount = 0;
  var APILoaded = false;
  var videoPercentages;

  window.setVideoPercentages = function () {
    videoPercentages = [100, 75, 50, 25, 10];
  };

  function loadAPI() {
    if (!APILoaded) {
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      APILoaded = true;
    }
  }

  function initPlayers() {
    var options = {
      bladeContainerSelector: '[video-blade]',
      triggerSelector: '[video-trigger]',
      instanceIdAttribute: 'video-id',
      instanceSourceAttribute: 'video-source',
      targetAreaSelector: '[video-target]',
      targetAreaWrapperSelector: '[video-target-container]',
      targetAreaCloseSelector: '[video-action-close]',
    };
    var playerElements = $(options.bladeContainerSelector);
    if (playerElements.length) {
      for (var i = 0; i < playerElements.length; i++) {

        var blade = $(playerElements[i]);
        var trigger = blade.find(options.triggerSelector);
        var close = blade.find(options.targetAreaCloseSelector);
        var target = blade.find(options.targetAreaSelector);
        var container = blade.find(options.targetAreaWrapperSelector);

        var thisPlayer = new YouTubePlayerObject(
          trigger.attr(options.instanceSourceAttribute),
          close, target, container, 0,
        );
        thisPlayer.init();
        players.push(thisPlayer);

      }
    }
  }

  function YouTubePlayerObject(sourceId, closeButton, componentTarget, componentContainer, autoplay) {
    var player = this;
    player.id = 'youTubeEmbed_' + sourceId + '_' + videoCount;
    player.sourceId = sourceId;
    player.autoplay = autoplay;

    player.$closeButton = closeButton;
    player.$componentTarget = componentTarget;
    player.$componentContainer = componentContainer;

    player.playerObject = null;
    player.initialized = false;
    player.options = { videoOpenClass: 'video-open' };
    videoCount += 1;

    player.init = function () {
      // Append dummy div and assign ID
      var videoDomElement = $('<div>', { id: player.id });
      player.$componentContainer.append(videoDomElement);
      // Initialize IFRAME Embedding using YT API
      if (typeof (YT) !== 'undefined') {
        player.playerObject = new YT.Player(player.id, {
          videoId: player.sourceId,
          height: '100%',
          width: '100%',
          playerVars: {
            modestbranding: 1,
            rel: 0,
            showinfo: 0,
            wmode: 'opaque',
            iv_load_policy: 3,
            autoplay: player.autoplay,
          },
          events: {
            onReady: player.onPlayerReady,
            onStateChange: onPlayerStateChange,
          },
        });

        player.initialized = true;
      }
    };

    player.onPlayerReady = function () {
      player.bindEvents();
    };

    player.bindEvents = function () {
      if (player.$closeButton) {
        player.$closeButton.on('click', function (event) {
          player.$componentTarget.removeClass(player.options.videoOpenClass);
          player.stop();
        });
      }
    };

    player.pause = function () {
      clearInterval(window.percentageInterval);
      if (player.playerObject.pauseVideo) {
        player.playerObject.pauseVideo();
      }
    };

    player.stop = function () {
      clearInterval(window.percentageInterval);
      window.setVideoPercentages();
      if (player.playerObject.stopVideo) {
        player.playerObject.stopVideo();
      }
    };
  }

  function onPlayerStateChange(event) {

    // checks if tracking data is present
    if ($(event.target.getIframe()).parent().attr('data-video-tracking')) {
      var trackingData = JSON.parse($(event.target.getIframe()).parent().attr('data-video-tracking')
        .split("'")
        .join('"'));

      if (trackingData['Video Metadata'].video_title) { trackingData['Video Metadata'].video_title = event.target.getVideoData().title; }
      if (trackingData['Video Metadata'].video_event_duration) { trackingData['Video Metadata'].video_event_duration = event.target.getDuration(); }
      if (trackingData['Video Metadata'].video_id) {
        trackingData['Video Metadata'].video_id = event.target.getVideoData().video_id;
        trackingData['Video Metadata'].video_link = event.target.getVideoUrl();
      }
      // deleting video_milestone attribute for play/pause events
      if (trackingData['Video Metadata'].video_milestone) { delete trackingData['Video Metadata'].video_milestone; }

      // Video Play
      if (event.data === YT.PlayerState.PLAYING) {
        if (trackingData['Video Metadata'].video_action) { trackingData['Video Metadata'].video_action = 'Play'; }
        if (window.Acr && window.Acr.TrackingManager) {
          triggerClickActivity(trackingData);
        }
        clearInterval(window.percentageInterval);

        // Interval to check the percentages watched on the video
        window.percentageInterval = setInterval(function () {
          var currentPercentage = event.target.getCurrentTime() * 100 / event.target.getDuration();
          if (videoPercentages.length > 0 && videoPercentages[videoPercentages.length - 1] <= currentPercentage) {
            var videoCheckpoint = getCheckpointPercentage(currentPercentage);
            trackingData['Video Metadata'].video_milestone = Math.floor(currentPercentage) + '%';
            trackingData['Video Metadata'].video_action = 'milestone';
            if (window.Acr && window.Acr.TrackingManager) {
              triggerClickActivity(trackingData);
            }
          }
        }, 200);
      } else if (event.data === YT.PlayerState.PAUSED) { // video pause
        if (trackingData['Video Metadata'].video_action) { trackingData['Video Metadata'].video_action = 'Paused'; }
        if (window.Acr && window.Acr.TrackingManager) {
          triggerClickActivity(trackingData);
        }
        clearInterval(window.percentageInterval);
      } else if (event.data === YT.PlayerState.ENDED) { // video end
        // sending 100% checkpoint event
        trackingData['Video Metadata'].video_action = 'milestone';
        trackingData['Video Metadata'].video_milestone = '100%';
        if (window.Acr && window.Acr.TrackingManager) {
          triggerClickActivity(trackingData);
        }
        clearInterval(window.percentageInterval);
        window.setVideoPercentages();
        event.target.stopVideo();
      }
    }
  }

  function getCheckpointPercentage(currentPercentage) {
    var checkpointPorcentage = 0;
    for (var i = videoPercentages.length - 1; i >= 0; i--) {
      if (currentPercentage > videoPercentages[i]) {
        checkpointPorcentage = videoPercentages.pop();
      } else {
        return checkpointPorcentage;
      }
    }
  }

  function triggerClickActivity(object) {
    if (window.Acr && window.Acr.TrackingManager) {
      window.Acr.TrackingManager.sendTrackingActivity(JSON.parse(JSON.stringify(object)));
    }
  }
  function init() {
    loadAPI();
    initPlayers();
    window.setVideoPercentages();
  }

  return {
    init: init,
    YouTubePlayerObject: YouTubePlayerObject,
    onPlayerStateChange: onPlayerStateChange,
  };
}());
